.modal-content .modal-backdrop{opacity:.8;position:absolute;width:100%;height:100%;border-radius:6px}
/*# sourceMappingURL=modals-widget.component-ND5IUZ46.css.map */
